import { ArrowRight } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router";
import { Button, Heading, Text } from "../../components/elements";
import Link from "../../components/elements/Link";
import Header from "../../components/header/Header";
import TipBox from "../../components/preInterviewPage/TipBox";
import { PageRoute, PageState } from "../../constants";
import { generateInterviewUrlRaw } from "../../utils/urlUtility";
import "./PreInterviewPage.css";

const PreInterviewPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [candidateName, setCandidateName] = useState("");
    const [interviewUrl, setInterviewUrl] = useState("");

    useEffect(() => {
        const interviewId = searchParams.get("interviewId");
        const redirectUrl = searchParams.get("redirectUrl");
        const displayName = searchParams.get("displayName");
        if (interviewId) {
            setCandidateName(displayName ?? "");
            setInterviewUrl(
                generateInterviewUrlRaw(
                    interviewId,
                    redirectUrl ?? `${PageRoute.DASHBOARD}?state=${PageState.INTERVIEW_COMPLETED}`,
                    { accessToken: searchParams.get("token"), reuseToken: searchParams.get("reuse") },
                ),
            );
        } else {
            navigate("/", { replace: true });
        }
    }, [navigate, searchParams]);

    return (
        <main>
            <Header />
            <div className="pre-interview-page-wrapper">
                <div className="content-wrapper">
                    <div className="header-section">
                        <Heading
                            level="h2"
                            light
                            className="text-2xl md:text-4xl"
                        >{`${t("PreInterviewPage.Title_Hello")} ${candidateName}`}</Heading>
                        <Heading level="h5" className="mx-auto mt-2 max-w-xs text-base md:max-w-none md:text-xl">
                            {t("PreInterviewPage.Subtitle")}
                        </Heading>
                    </div>
                    <TipBox />
                    <div className="ready-to-start-container">
                        <Text weight="semibold" block className="text-base">
                            {t("PreInterviewPage.ReadyToGetStarted")}
                        </Text>
                        <Button link to={interviewUrl} className="apply-btn w-full">
                            <span className="me-2">{t("PreInterviewPage.ButtonText_StartInterviewNow")}</span>
                            <span>
                                <ArrowRight className="rtl:-scale-x-100" />
                            </span>
                        </Button>
                        <div className="flex flex-col items-center">
                            <Text className="text-xs">{`${t("PreInterviewPage.PrivacyPolicyText")} `}</Text>
                            <Link to="https://www.hubert.ai/candidate-privacy-policy" target="_blank">
                                <Text weight="semibold" className="text-xs">
                                    {t("PreInterviewPage.PrivacyPolicyLink")}
                                </Text>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default PreInterviewPage;
